import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  ButtonGroup,
  Button,
  CustomInput,
  Row,
  Label,
  Input,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import { localeOptions } from '../../../../../constants/defaultValues';
import Languages from '../../../../../data/languages';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import {
  InputStlye,
  SelectStyle,
  AvatarSizeStyle,
} from '../style/DigitalAssistantStyle';
import Select from 'react-select';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import LanguageTabs from '../../propinfo/components/LanguageTabs/LanguageTabs';
import { gAPI_Internal_Property_By_Id } from '../../../../../constants/APIs';
const getLocalStatement = (statements, selectedLang) => {
  if (statements !== undefined && statements !== null && statements.length > 0) {
    const index = statements.findIndex((m) => m.locale === selectedLang);
    if (index === -1) {
      const englishIndex = statements.findIndex((m) => m.locale === 'en');
      if (englishIndex !== -1) {
        return statements[englishIndex].statement;
      }
    } else {
      return statements[index].statement;
    }
  } else {
    return '';
  }
};

export default function MultliLanguages({ botSettings, saveIntegration, isHelpcenter, locale, menuItems = [],
  conversationFlowList = [], integration, group }) {
  const canonicalLocale = (locale) => {
    if (locale === "zh-TW" || locale === "hk") return "hk";
    return locale;
  };
  const [edit, setEdit] = useState(false);
  const [settings, setSetting] = useState(botSettings);
  const [botLanguages, setBotLanguages] = useState([]);
  const [botLanguagesList, setBotLanguagesList] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: 'en',
    label: 'English',
  });
  const [defaultUrls, setDefaultUrls] = useState([
    { url: "", languageCode: "" }
  ]);
  const [isAutoDetectLanguage, setIsAutoDetectLanguage] = useState(botSettings?.features !== null &&
    botSettings?.features.autoLanguageDetection !== undefined ? botSettings?.features.autoLanguageDetection : false);
  const [isDefaultLanguageUrl, setIsDefaultLanguageUrl] = useState(botSettings?.features !== null &&
    botSettings?.features.defaultLanguageUrl !== undefined ? botSettings?.features.defaultLanguageUrl : false);
  const [languageInstructions, setLanguageInstructions] = useState(botSettings?.languageInstructions !== null &&
    botSettings?.languageInstructions !== undefined ? botSettings?.languageInstructions : "");
  const [selectedLang, setSelectedLang] = useState(locale);
  const [propertyLanguages, setPropertyLanguages] = useState([]);
  const [assistantDetail, setAssistantDetail] = useState({
    name: "",
    title: "",
    subTitle: "",
    locale,
    suggestionBotSetting: {
      message: [{ statement: "How can I help?", locale }],
      buttons: [{
        text: '',
        subTitle: '',
        value: '',
        actionType: 'SendToChatBot',
        locale
      }],
      placeHolderText: [{ statement: "Ask me anything about the hotel...", locale }],
    }
  });
  console.log('botSE', integration, propertyLanguages)
  const [chatBotDetails, setChatBotDetails] = useState({
    title: "",
    subTitle: "",
    contactInformation: "",
    locale
  });
  useEffect(() => {
    if (!integration?.properties?.length) {
      setPropertyLanguages(Languages);
      return;
    }

    const loadPropertyLanguages = async () => {
      try {
        const responses = await Promise.all(
          integration?.properties.map((propertyId) =>
            AxiosAPI({
              methhod: 'get',
              url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group}`,
            })
          )
        );
        const languageCodes = [
          ...new Set(
            responses.flatMap(
              (res) => res?.data?.languages || []
            )
          ),
        ];
        const availableLanguages = Languages?.filter((lang) =>
          languageCodes.includes(lang.code)
        );
        setPropertyLanguages(availableLanguages);
      } catch (err) {
        console.error('Error loading property languages', err);
        setPropertyLanguages(Languages);
      }
    };

    loadPropertyLanguages();
  }, [integration?.properties, group]);
  useEffect(() => {
    if (!propertyLanguages?.length) return;

    const getLanguage = propertyLanguages?.filter(
      (item) => item.code === botSettings?.defaultLanguage
    );

    const filtered = propertyLanguages?.filter((el) => {
      return botSettings?.languages.indexOf(el.code) !== -1;
    });
    setBotLanguages(filtered);

    const languageList = propertyLanguages?.map((elem) => {
      elem.checked = false;
      filtered.forEach((lang) => {
        if (lang.code === elem.code) {
          elem.checked = true;
        }
      });
      return elem;
    });

    setBotLanguagesList(languageList);

    if (getLanguage?.length > 0) {
      setSelectedLanguage({
        value: getLanguage[0]?.code,
        label: getLanguage[0]?.name,
      });
    }

    if (botSettings?.features !== undefined && botSettings?.features !== null &&
      botSettings?.features.languageUrl !== undefined &&
      botSettings?.features.languageUrl !== null && botSettings?.features.languageUrl?.length > 0) {
      let links = [];
      botSettings?.features.languageUrl.map((m) =>
        links.push({
          url: m.url,
          languageCode: m.languageCode,
        }));
      setDefaultUrls(links);
    }
  }, [botSettings, propertyLanguages]);

  useEffect(() => {
    loadLanguageData(selectedLang);
  }, [settings, selectedLang]);

  const loadLanguageData = (lang) => {
    const key = canonicalLocale(lang);

    const assistant = settings.assistantDetails?.find(
      d => canonicalLocale(d.locale) === key
    );

    const rootSuggestion = settings.suggestionBotSetting || {};

    const messagesForLang = Array.isArray(rootSuggestion.message)
      ? rootSuggestion.message.filter(
        m => m && canonicalLocale(m.locale) === key
      )
      : [];

    const placeholdersForLang = Array.isArray(rootSuggestion.placeHolderText)
      ? rootSuggestion.placeHolderText.filter(
        m => m && canonicalLocale(m.locale) === key
      )
      : [];

    const buttonsForLang = Array.isArray(rootSuggestion.buttons)
      ? rootSuggestion.buttons.filter(
        b => b && canonicalLocale(b.locale) === key
      )
      : [];

    const englishMessages = Array.isArray(rootSuggestion.message)
      ? rootSuggestion.message.filter(
        m => canonicalLocale(m.locale) === "en"
      )
      : [];

    const englishPlaceholders = Array.isArray(rootSuggestion.placeHolderText)
      ? rootSuggestion.placeHolderText.filter(
        m => canonicalLocale(m.locale) === "en"
      )
      : [];

    const englishButtons = Array.isArray(rootSuggestion.buttons)
      ? rootSuggestion.buttons.filter(
        b => canonicalLocale(b.locale) === "en"
      )
      : [];

    const suggestionBotSetting = {
      message:
        messagesForLang.length > 0
          ? messagesForLang
          : englishMessages.map(m => ({
            ...m,
            locale: lang
          })),
      placeHolderText:
        placeholdersForLang.length > 0
          ? placeholdersForLang
          : englishPlaceholders.map(m => ({
            ...m,
            locale: lang
          })),
      buttons:
        buttonsForLang.length > 0
          ? buttonsForLang
          : englishButtons.map(b => ({
            ...b,
            locale: lang
          })),
    };
    setAssistantDetail(
      assistant
        ? {
          ...assistant,
          suggestionBotSetting,
        }
        : {
          name: "",
          title: "",
          subTitle: "",
          locale: lang,
          suggestionBotSetting,
        }
    );

    const chatbot = settings.chatBot?.chatBotDetails?.find(
      d => canonicalLocale(d.locale) === key
    );

    setChatBotDetails(
      chatbot || {
        title: "",
        subTitle: "",
        contactInformation: "",
        locale: lang
      }
    );
  };

  const handleSave = () => {
    setEdit(!edit);
    const updatedSettings = {
      ...settings,
      features: {
        ...settings.features,
        ...(defaultUrls?.length > 0 && { languageUrl: defaultUrls }),
      },
      languageInstructions: languageInstructions,
    };

    saveIntegration({ botSetting: updatedSettings });
  };


  const handleChangeSelect = (selectedOptions) => {
    setSelectedLanguage(selectedOptions);
    setSetting({
      ...settings,
      defaultLanguage: selectedOptions.value,
    });
  };

  const handleLanguageChange = (e) => {
    const values = botLanguagesList.map((elem) => {
      if (elem.code === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setBotLanguagesList(values);
  };

  useEffect(() => {
    const langArr = botLanguagesList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.code);

    //console.log(langArr);

    setSetting({
      ...settings,
      languages: langArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botLanguagesList]);

  const handleChangeURL = (e, index) => {
    const values = [...defaultUrls];
    if (e.target.name === 'url') {
      values[index].url = e.target.value;
    }
    setDefaultUrls(values);
  }
  const handleChangeLanguageCode = (lang, index) => {
    const values = [...defaultUrls];
    values[index].languageCode = lang.value;
    setDefaultUrls(values);
  }
  const AddURL = () => {
    let links = [...defaultUrls];;
    links.push({
      url: '',
      languageCode: '',
    });
    setDefaultUrls(links);
  };

  const RemoveURL = (index) => {
    const values = [...defaultUrls];
    values.splice(index, 1);
    setDefaultUrls(values);
  };
  const handleChange = (e) => {
    const value = e.target.checked;
    setSetting({
      ...settings,
      [e.target.name]: value,
    });
  };
  const handleMultilingualChange = (checked) => {
    const updatedSettings = {
      ...settings,
      multilingual: checked,
    };

    setSetting(updatedSettings);

    setTimeout(() => {
      NotificationManager.success(
        '',
        checked ? 'Languages enabled successfully' : 'Languages disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);

    saveIntegration({ botSetting: updatedSettings });
  };
  const handleAutoLanguageDetection = (e) => {
    setIsAutoDetectLanguage(e);

    const updatedSettings = {
      ...settings,
      features: {
        ...settings.features,
        autoLanguageDetection: e
      }
    };

    setSetting(updatedSettings);
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true ? 'Auto language detection enabled successfully' : 'Auto language detection disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: updatedSettings });
  };


  const handleDefaultLanguageUrl = (e) => {
    setIsDefaultLanguageUrl(e);
    settings.features.defaultLanguageUrl = e;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true ? 'Default language url enabled successfully' : 'Default language url disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: settings });
  };

  /* ==================== Suggestion Bot Handlers ==================== */

  const handleSuggestionTextChange = (e) => {
    setAssistantDetail(prev => {
      if (prev.suggestionBotSetting.message !== undefined &&
        prev.suggestionBotSetting.message !== null &&
        prev.suggestionBotSetting.message.length > 0) {
        const index = prev.suggestionBotSetting.message.findIndex((m) => m.locale === selectedLang);
        let messages = [...prev.suggestionBotSetting.message];
        if (index === -1) {
          const newStatement = {
            statement: e.target.value,
            locale: selectedLang,
          };
          messages = [...prev.suggestionBotSetting.message, newStatement];
        } else {
          messages[index].statement = e.target.value;
        }
        return {
          ...prev,
          suggestionBotSetting: {
            ...prev.suggestionBotSetting,
            message: messages
          }
        };
      }
      return prev;
    });
  };

  const handleSuggestionPlaceholderTextChange = (e) => {
    setAssistantDetail(prev => {
      if (prev.suggestionBotSetting.placeHolderText !== undefined &&
        prev.suggestionBotSetting.placeHolderText !== null &&
        prev.suggestionBotSetting.placeHolderText.length > 0) {
        const index = prev.suggestionBotSetting.placeHolderText.findIndex((m) => m.locale === selectedLang);
        let placeholders = [...prev.suggestionBotSetting.placeHolderText];
        if (index === -1) {
          const newStatement = {
            statement: e.target.value,
            locale: selectedLang,
          };
          placeholders = [...prev.suggestionBotSetting.placeHolderText, newStatement];
        } else {
          placeholders[index].statement = e.target.value;
        }
        return {
          ...prev,
          suggestionBotSetting: {
            ...prev.suggestionBotSetting,
            placeHolderText: placeholders
          }
        };
      }
      return prev;
    });
  };

  const handleAddFields = () => {
    const newButton = {
      text: '',
      subTitle: '',
      value: '',
      actionType: 'SendToChatBot',
      locale: selectedLang
    };
    setAssistantDetail(prev => {
      const suggestionsBot = prev?.suggestionBotSetting || {
        message: [],
        placeHolderText: [],
        buttons: []
      };
      return {
        ...prev,
        suggestionBotSetting: {
          ...suggestionsBot,
          buttons: [...(suggestionsBot.buttons || []), newButton]
        }
      };
    });
  };

  const handleRemoveFields = (index) => {
    setAssistantDetail(prev => {
      const suggestionsBot = prev?.suggestionBotSetting;
      if (!suggestionsBot || !suggestionsBot.buttons) return prev;
      return {
        ...prev,
        suggestionBotSetting: {
          ...suggestionsBot,
          buttons: suggestionsBot.buttons.filter((_, i) => i !== index)
        }
      };
    });
  };

  const handleInputChange = (index, event) => {
    const { name: inputName, value: inputValue } = event.target;
    setAssistantDetail((prev) => {
      const suggestionsBot = prev?.suggestionBotSetting;
      if (!suggestionsBot || !suggestionsBot.buttons || !suggestionsBot.buttons[index]) return prev;

      const updatedButtons = suggestionsBot.buttons.map((b, i) => {
        if (i !== index) return b;
        const base = { ...b, [inputName]: inputValue, locale: selectedLang };
        if (inputName === 'actionType') return { ...base, value: '' };
        return base;
      });
      return {
        ...prev,
        suggestionBotSetting: {
          ...suggestionsBot,
          buttons: updatedButtons,
        },
      };
    });
  };

  const handleActionValueChange = (index, value) => {
    setAssistantDetail((prev) => {
      const suggestionsBot = prev?.suggestionBotSetting;
      if (!suggestionsBot || !suggestionsBot.buttons || !suggestionsBot.buttons[index]) return prev;

      const updatedButtons = suggestionsBot.buttons.map((b, i) => (i === index ? { ...b, value, locale: selectedLang } : b));
      return {
        ...prev,
        suggestionBotSetting: {
          ...suggestionsBot,
          buttons: updatedButtons,
        },
      };
    });
  };

  const renderActionValueField = (nudge, index) => {
    if (nudge.actionType === 'OPEN_URL') {
      return (
        <Colxx sm={5} className="mb-3">
          <Label>Open URL</Label>
          <Input
            type="text"
            name="value"
            value={nudge.value}
            onChange={(e) => handleActionValueChange(index, e.target.value)}
            placeholder="URL"
          />
        </Colxx>
      );
    }
    if (nudge.actionType === 'OPEN_WIDGET_MENU') {
      return (
        <Colxx sm={5} className="mb-3">
          <Label>Menu Item</Label>
          <Input
            type="select"
            name="value"
            value={nudge.value || ''}
            onChange={(e) => handleActionValueChange(index, e.target.value)}
            disabled
          >
            <option value="">Select</option>
            {menuItems.map((m) => (
              <option key={m.id} value={m.id}>
                {m.title}
              </option>
            ))}
          </Input>
        </Colxx>
      );
    }
    if (nudge.actionType === 'STATIC_FLOW') {
      return (
        <Colxx sm={5} className="mb-3">
          <Label>Conversation Flow</Label>
          <Input
            type="select"
            name="value"
            value={nudge.value || ''}
            onChange={(e) => handleActionValueChange(index, e.target.value)}
            disabled
          >
            <option value="">Select</option>
            {conversationFlowList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </Input>
        </Colxx>
      );
    }
    return null;
  };


  const SwitchLanguage = (lang) => {
    setSelectedLang(lang);
  };

  const handleSubmit = () => {
    const saveLocale = canonicalLocale(selectedLang);

    const existingRoot = settings.suggestionBotSetting || {};


    const otherLocaleMessages = Array.isArray(existingRoot.message)
      ? existingRoot.message.filter(
        m => canonicalLocale(m.locale) !== saveLocale
      )
      : [];

    const otherLocalePlaceholders = Array.isArray(existingRoot.placeHolderText)
      ? existingRoot.placeHolderText.filter(
        m => canonicalLocale(m.locale) !== saveLocale
      )
      : [];

    const otherLocaleButtons = Array.isArray(existingRoot.buttons)
      ? existingRoot.buttons.filter(
        b => canonicalLocale(b.locale) !== saveLocale
      )
      : [];

    const draftMessages = (assistantDetail.suggestionBotSetting?.message || [])
      .filter(m => m.statement?.trim() !== "")
      .map(m => ({ ...m, locale: saveLocale }));

    const draftPlaceholders = (assistantDetail.suggestionBotSetting?.placeHolderText || [])
      .filter(m => m.statement?.trim() !== "")
      .map(m => ({ ...m, locale: saveLocale }));

    const draftButtons = (assistantDetail.suggestionBotSetting?.buttons || [])
      .filter(b =>
        b.text?.trim() !== "" ||
        b.subTitle?.trim() !== "" ||
        b.value?.trim() !== ""
      )
      .map(b => ({ ...b, locale: saveLocale }));

    const hasChanges =
      draftMessages.length > 0 ||
      draftPlaceholders.length > 0 ||
      draftButtons.length > 0;

    if (!hasChanges) {
      saveIntegration({ botSetting: settings });
      return;
    }

    const suggestionBotSetting = {
      ...existingRoot,
      message: [...otherLocaleMessages, ...draftMessages],
      placeHolderText: [...otherLocalePlaceholders, ...draftPlaceholders],
      buttons: [...otherLocaleButtons, ...draftButtons],
    };

    const updatedSettings = {
      ...settings,
      suggestionBotSetting,
      assistantDetails: [
        ...(settings.assistantDetails || []).filter(
          d => canonicalLocale(d.locale) !== saveLocale
        ),
        { ...assistantDetail, locale: saveLocale }
      ],
      chatBot: {
        ...(settings.chatBot || {}),
        chatBotDetails: [
          ...((settings.chatBot?.chatBotDetails) || []).filter(
            d => canonicalLocale(d.locale) !== saveLocale
          ),
          { ...chatBotDetails, locale: saveLocale }
        ]
      }
    };
    setSetting(updatedSettings);
    saveIntegration({ botSetting: updatedSettings });
  };

  const Show = () => {
    return (
      <Fragment>
        {botSettings ? (
          <div>
            <div className="text-center">
              <h6>Languages</h6>
            </div>
            <Separator className="mb-3" />
            <div className="my-3 px-4 text-left">
              <div className="mb-3">
                <h6>Default Language:</h6> {selectedLanguage.label}
              </div>
              <div className="mb-3">
                <h6>Enable Multi Language:</h6>
                {botSettings?.multilingual ? ' Yes' : ' No'}
              </div>
              {botLanguages?.length > 0 ?
                <div className="mb-3">
                  <h6>Selected Languages:</h6>
                  <Row>
                    {botLanguages.map((lang, msgIndex) => {
                      return (
                        <Colxx xxs="4" key={msgIndex} className="mt-2">
                          {' '}
                          <span className="text-left">{lang.name}</span>
                        </Colxx>
                      );
                    })}
                  </Row>
                </div>
                : <span>No languages are currently enabled for this property. Please ask an admin to enable additional languages.</span>
              }
              {isHelpcenter && (
              <Fragment>
                <div className='text-left'>
                  <div className="my-3">
                    <h6>Auto Language Detection:</h6>
                    {botSettings?.features.autoLanguageDetection ? ' Yes' : ' No'}
                  </div>
                  <div className="mb-3">
                    <h6>Default Language URL:</h6>
                    {botSettings?.features.defaultLanguageUrl ? ' Yes' : ' No'}
                  </div>
                </div>
                <div className="mb-3">
                  <h6>Languages URLs:</h6>
                  {defaultUrls?.length > 0 && defaultUrls.filter(k => k.url !== "")?.length !== 0 ?
                    <Fragment>
                      <Row className='mb-2'>
                        <Colxx xxs="8"><b>URLs</b></Colxx>
                        <Colxx xxs="4"><b>Language Code</b></Colxx>
                      </Row>
                      {defaultUrls.map((lang, i) => {
                        return (
                          <Row className="" key={i}>
                            <Colxx xxs="8">
                              {' '}
                              <span className="text-left"><a href={`${lang.url}`} rel="noopener noreferrer" target="_blank">{lang.url}</a></span>
                            </Colxx>
                            <Colxx xxs="4">
                              <span>{lang.languageCode}</span>
                            </Colxx>
                          </Row>
                        );
                      })}
                    </Fragment>
                    : <span className='mt-2'>{' '}No Urls Available</span>}
                </div>
              </Fragment>
              )}
              {isHelpcenter === true ? '' : (
                <Fragment>
                  {languageInstructions !== null && languageInstructions !== "" &&
                    <div className="mb-1">
                      <h6>Language Instructions</h6>
                      <p className="text-left">{languageInstructions}</p>
                    </div>
                  }
                </Fragment>
              )}
            </div>
            <Separator className="mx-2" />
            <div className='text-center my-3' >
              <Button
                size="xs"
                color="success"
                outline
                onClick={() => {
                  setEdit(!edit);
                }}
              >
                Edit
              </Button>
            </div>

          </div>
        ) : null
        }
      </Fragment >
    );
  };

  function Edit() {
    return (
      <Fragment>
        {botSettings ? (
          <>
            <div className="text-center">
              <h6>Languages</h6>
            </div>
            <Separator className="mb-3" />
            <div className="p-4">
              <div className="mb-3">
                <h6>Default Language</h6>
                <Select
                  isMulti={false}
                  className="react-select mt-2"
                  classNamePrefix="react-select"
                  name="defaultLanguage"
                  value={selectedLanguage}
                  placeholder="Select Default Language"
                  onChange={handleChangeSelect}
                  options={
                    propertyLanguages
                      ? reactSelectOptionDiffrentPro(
                        botLanguages,
                        true,
                        'code',
                        'name',
                        ''
                      )
                      : []
                  }
                />
              </div>
              <div className="mb-2 mt-2 text-left">
                <div className="d-flex w-100">
                  <h6 style={{ marginTop: "0.15rem" }}>Enable Multi Language</h6>
                  {/* <CustomInput
                  id="lan"
                  type="checkbox"
                  checked={settings.multilingual}
                  name="multilingual"
                  onChange={handleChange}
                /> */}
                  <Switch id="lan" className="agentswitch custom-switch-primary custom-switch-small ml-2 "
                    checked={settings.multilingual}
                    onChange={handleMultilingualChange}
                    disabled={botLanguagesList?.length > 0 ? false : true}
                  />
                </div>
              </div>
              {botLanguagesList?.length > 0 &&
                <div className="mb-2 mt-2 text-left">
                  <h6>Choose Languages</h6>
                  <Row className='mt-2'>
                    {botLanguagesList?.map((elem, index) => (
                      <Colxx xxs="4" key={index}>
                        {' '}
                        <CustomInput
                          key={index}
                          type="checkbox"
                          value={elem.code}
                          id={elem.code}
                          onChange={handleLanguageChange}
                          checked={elem.checked}
                          className="text-left"
                        >
                          {elem?.name}
                        </CustomInput>
                      </Colxx>
                    ))}
                  </Row>
                </div>
              }
              <div className="row mt-3 ml-0 mb-1">
                <div className="d-flex w-100">
                  <h6 style={{ marginTop: "0.15rem" }}>Auto language detection</h6>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={isAutoDetectLanguage}
                    name='enabled'
                    onChange={(e) => handleAutoLanguageDetection(e)}
                  />
                </div>
                <div className="row text-left" style={{ marginLeft: '0', marginRight: '1rem' }}>
                  {isAutoDetectLanguage === false ?
                    <p className="my-1 pr-2">When enabled, the language will be auto detected based on the first two messages guest sends. Rest of the conversation will be in that language.</p>
                    :
                    <ul className='pl-2 pr-2'>
                      <li>the AI Chatbot will attempt to detect the language based on the customer message and respond in the same language.</li>
                      <li>the first 5 customer messages are detected, and the responses after that are set to the language of the 5th message.</li>
                      <li>if the customer message is not in one of the enabled languages, AI Chatbot will respond with “Sorry, I do not support this language”. The message is sent in the same language as the user message.</li>
                    </ul>
                  }
                </div>
              </div>
              {isHelpcenter === true &&
                <Fragment>
                  <div className='row mt-3 ml-2 mb-1'>
                    <div className="d-flex w-100">
                      <h6>Default language by URL</h6>
                      <Switch
                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                        checked={isDefaultLanguageUrl}
                        name='enabled'
                        onChange={(e) => handleDefaultLanguageUrl(e)}
                      />
                    </div>
                  </div>
                  {defaultUrls?.length > 0 &&
                    defaultUrls.map((elem, index) => (
                      <Row className="mt-2" key={index}>
                        <Colxx md={"6"}>
                          <Input
                            type="textarea"
                            value={elem.url}
                            onChange={(e) => handleChangeURL(e, index)}
                            name="url"
                            placeholder="URL"
                            style={{ height: "40px" }}
                          ></Input>
                        </Colxx>
                        <Colxx md={"4"}>
                          <Select
                            isMulti={false}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="languageCode"
                            value={propertyLanguages?.filter(l => l.code === elem.languageCode).map(x => ({ label: x.name, value: x.code }))}
                            placeholder="Select Language"
                            onChange={(e) => handleChangeLanguageCode(e, index)}
                            options={
                              propertyLanguages
                                ? reactSelectOptionDiffrentPro(
                                  propertyLanguages,
                                  true,
                                  'code',
                                  'name',
                                  ''
                                )
                                : []
                            }
                          />
                        </Colxx>
                        <Colxx md={"2"}>
                          <Button color="danger" size="xs" outline onClick={() => RemoveURL(index)}>X</Button>
                        </Colxx>
                      </Row>
                    ))}
                  <div className='row mt-3 ml-2 mb-1'>
                    <Button color="success" size="xs" outline onClick={AddURL}>+Add</Button>
                  </div>
                </Fragment>
              }
              {isHelpcenter === true ? '' : (
                <Fragment>
                  <div className=''>
                    <h6>Language Instructions</h6>
                    <Input
                      className="mt-2"
                      type="textarea"
                      rows="3"
                      value={languageInstructions}
                      onChange={e => {
                        setLanguageInstructions(e.target.value);
                      }}
                    />
                  </div>
                </Fragment>
              )}
            </div>
            <Separator className="mx-2" />
            <div className='my-3 text-center'>
              <Button color="primary" size="xs" onClick={handleSave}>
                Save
              </Button>
              <Button className='ml-2'
                size="xs"
                color="secondary"

                onClick={() => {
                  setEdit(!edit);
                }}
              >
                Cancel
              </Button>
            </div>
          </>
        ) : null}
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody className="mx-0">
          {edit ? Edit() : Show()}
        </CardBody>
      </Card>
      <Card className=''>
        <CardBody className='mx-0'>
          <h6 className="text-center">Set up all language specific text for the web widget at one place</h6>
          <div className="p-3 text-left">
            <Row className='mb-2 '>
              <LanguageTabs
                integrationLanguages={settings.languages}
                selectedTab={selectedLang}
                setLanguage={(e) => SwitchLanguage(e)}
              ></LanguageTabs>
            </Row>
            <div className='mb-3'>
              <h6>Widget Components</h6>
              <Card className="p-3 my-2">
                <div className='mb-2'>
                  <Label className='pl-1'>Assistant Name</Label>
                  <Input
                    name="name"
                    value={assistantDetail?.name ?? ""}
                    onChange={e =>
                      setAssistantDetail({ ...assistantDetail, name: e.target.value })
                    }
                  />
                </div>
                <div className='mb-2'>
                  <Label className='pl-1'>Title</Label>
                  <Input
                    name="title"
                    value={assistantDetail?.title ?? ""}
                    onChange={e =>
                      setAssistantDetail({ ...assistantDetail, title: e.target.value })
                    }
                  />
                </div>
                <div className='mb-2'>
                  <Label className='pl-1'>SubTitle</Label>
                  <Input
                    name="subTitle"
                    value={assistantDetail?.subTitle ?? ""}
                    onChange={e =>
                      setAssistantDetail({ ...assistantDetail, subTitle: e.target.value })
                    }
                  />
                </div>
              </Card>
            </div>
            <div className='mt-3'>
              <h6>Suggestions</h6>
              <Card className="p-3 my-2">
                {/* Messages */}
                <div className="mb-2">
                  <Label className='pl-1'>Hero Message</Label>
                  <Input
                    type="textarea"
                    name="text"
                    value={getLocalStatement(assistantDetail?.suggestionBotSetting?.message, selectedLang)}
                    onChange={event => handleSuggestionTextChange(event)}
                  />
                </div>

                {/* Typing Placeholder Text */}
                <div className="mb-2">
                  <Label className='pl-1'>Typing Placeholder Text</Label>
                  <Input
                    type="text"
                    name="text"
                    value={getLocalStatement(assistantDetail?.suggestionBotSetting?.placeHolderText, selectedLang)}
                    onChange={event => handleSuggestionPlaceholderTextChange(event)}
                  />
                </div>

                {/* Buttons */}
                <div className="mb-2">
                  <Label className='pl-1'>Suggestion Buttons</Label>
                  {assistantDetail?.suggestionBotSetting?.buttons && assistantDetail.suggestionBotSetting.buttons.length > 0 ? (
                    assistantDetail.suggestionBotSetting.buttons.map((nudge, index) => (
                      <Fragment key={index}>
                        <Card className="p-3 mb-3">
                          <Row className="pb-2">
                            <Colxx sm={5} className="mb-3">
                              <b className='p-1'>Title</b>
                              <Input
                                type="text"
                                name="subTitle"
                                placeholder="Title must be 10-20 characters"
                                value={nudge.subTitle}
                                onChange={event => handleInputChange(index, event)}
                              />
                            </Colxx>
                            <Colxx sm={5} className="mb-3">
                              <b className='p-1'>Sub Title</b>
                              <Input
                                type="text"
                                name="text"
                                placeholder="SubTitle must be 10-20 characters"
                                value={nudge.text}
                                onChange={event => handleInputChange(index, event)}
                              />
                            </Colxx>
                            <Colxx sm={5} className="">
                              <b className='p-1'>Action Type</b>
                              <Input
                                type="select"
                                name="actionType"
                                value={nudge.actionType || 'SendToChatBot'}
                                onChange={event => handleInputChange(index, event)}
                                disabled
                              >
                                <option value="SendToChatBot">Send to Chatbot</option>
                                <option value="OPEN_WIDGET_MENU">Open Web Widget Menu</option>
                                <option value="OPEN_URL">Open URL</option>
                                <option value="STATIC_FLOW">Trigger Static Conversation Flow</option>
                              </Input>
                            </Colxx>
                            {renderActionValueField(nudge, index)}
                            {(nudge.actionType === 'SendToChatBot') && (
                              <Colxx sm={5} className="">
                                <b className='p-1'>Chatbot Message</b>
                                <Input
                                  type="text"
                                  name="value"
                                  value={nudge.value}
                                  onChange={event => handleInputChange(index, event)}
                                />
                              </Colxx>
                            )}

                            <Colxx
                              sm={2}
                            // style={{
                            //   marginTop: "-37px",
                            // }}
                            >
                              <b style={{ marginLeft: '-5px' }}>Remove</b>
                              <div>
                                <Button
                                  onClick={() => handleRemoveFields(index)}
                                  color="secondary"
                                  size="xs"
                                  outline
                                  style={{ margin: '4px' }}
                                >
                                  X
                                </Button>
                              </div>
                            </Colxx>
                          </Row>
                        </Card>
                      </Fragment>
                    ))
                  ) : (
                    <Card className="p-3 mb-3 text-center text-muted">No buttons added yet</Card>
                  )}
                  <Button
                    onClick={handleAddFields}
                    color="primary"
                    size="xs"
                    outline
                  >
                    + Add Button
                  </Button>
                </div>
              </Card>
            </div>

            <div className='mt-3'>
              <h6>Chatbot Info</h6>
              <Card className="p-3 mt-2">
                <div className='mb-2'>
                  <Label className='pl-1'>Title</Label>
                  <Input
                    type="text"
                    name="title"
                    placeholder="Title"
                    value={chatBotDetails?.title ?? ""}
                    onChange={e =>
                      setChatBotDetails({ ...chatBotDetails, title: e.target.value })
                    }
                  ></Input>
                </div>
                <div className='mb-2'>
                  <Label className='pl-1'>SubTitle</Label>
                  <Input
                    type="text"
                    name="subTitle"
                    placeholder="Sub Title"
                    value={chatBotDetails?.subTitle ?? ""}
                    onChange={e =>
                      setChatBotDetails({ ...chatBotDetails, subTitle: e.target.value })
                    }
                  ></Input>
                </div>
              </Card>
            </div>
          </div>
          <Separator className="mb-3 mx-2" />
          <div className='mb-3 text-center'>
            <Button color="primary" size="xs" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </CardBody>
      </Card>
    </Fragment >
  )
}
